import { ErrorState } from "@evolua/ui";
import { describeApiError } from "./error-ui.js";
import { useOnlineStatus } from "../pwa/use-online-status.js";

type Props = {
  error: unknown;
  onRetry?: () => void;
  retryLabel?: string;
};

/** ErrorState com copy tipada (offline / cold start / Problem Details). */
export function QueryErrorState({ error, onRetry, retryLabel }: Props) {
  const online = useOnlineStatus();
  const described = describeApiError(error, { online });
  return (
    <ErrorState
      title={described.title}
      description={described.description}
      {...(described.correlationId ? { correlationId: described.correlationId } : {})}
      {...(onRetry ? { onRetry, retryLabel } : {})}
    />
  );
}
